module.exports = __webpack_public_path__ + "static/media/newbridge.6e9581c7.png";